import { PrecheckPartnerLeadRequestSchema, PrecheckPartnerLeadResponseSchema } from './precheck-partner-lead.schema';
/**
 * Pre-check Partner Lead Email Endpoint Contract
 * Dedupe gate used after the lead form's step 1 (before appointment selection):
 * returns whether the email already exists in HubSpot. The partner is resolved
 * server-side from the JWT.
 */ export const precheckPartnerLeadContract = {
    method: 'POST',
    path: '/api/v2/partner/leads/precheck',
    description: 'Checks whether a lead email already exists in HubSpot (dedupe gate before booking)',
    requestSchema: PrecheckPartnerLeadRequestSchema,
    responseSchema: PrecheckPartnerLeadResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid email',
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - tenant is not a HubSpot-linked partner'
        }
    }
};

//# sourceMappingURL=precheck-partner-lead.contract.js.map